import React from "react";
import Header from "../../Component/Header";
import Importantdates from "../Importantdates";
import Footer from "../../Component/Footer";

export default function LayoutImportantdates() {
  return (
    <>
      <Header />
      <Importantdates />
      <Footer />
    </>
  );
}
